import { getObjectTypeIconComponent } from 'customer-data-objects-ui-components/objects/getObjectTypeIconComponent';
import { useCardContextValue } from '../state/CardContext';
import { CustomObjectIcon } from 'foundations-assets/icons/components/CustomObjectIcon';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarIcon = ({
  size = 'large'
}) => {
  const {
    objectTypeId
  } = useCardContextValue();
  const IconComponent = getObjectTypeIconComponent(objectTypeId, {
    DefaultIconComponent: CustomObjectIcon
  });
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "highlight-avatar-icon",
    inlineSize: size === 'large' ? '48px' : '24px',
    blockSize: size === 'large' ? '48px' : '24px',
    backgroundColor: "fill-accent-neutral-subtle-alt",
    borderColor: "fill-accent-neutral-subtle-alt",
    borderRadius: "full",
    borderWidth: "100",
    alignItems: "center",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(IconComponent, {
      size: size === 'large' ? '500' : '100'
    })
  });
};
export default AvatarIcon;